// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__EoTSz","name":"Header_name__1XP4f","birthday":"Header_birthday__1tzdr","skeleton":"Header_skeleton__Wxfhb"};